




































































































































































































































































































































import {Component, Ref, Vue} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {Collapse, DatePickerWings, SelectWings, SpoilerWings, ToggleWings} from "wings-ui-components";
import {CollapseTransition} from "vue2-transitions";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {PartnerItem} from "@/store/settings/partners/types";
import {AllowedPage, UserRoleItem} from "@/store/user_management/roles/types";
import {dynamicSort} from "@/utils/data-helper";
import { TransportItem } from '@/store/transport/types';
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {
  SelectWings, DatePickerWings,
  ToggleWings, Collapse, SpoilerWings, CollapseTransition
}})
export default class UserRole extends Vue {
  @Action("getUserRoleItem") actionGetItem: any;
  @Action("getSystemPages") actionGetPages: any;
  @Action("saveUserRole") actionSave: any;
  @Action("deleteUserRole") actionDelete: any;
  @Action("actionLog") actionLog: any;
  @Ref('validator') validator: any;

  @Getter("transports") transportsList!: TransportItem[];
  @Action("getTransports") actionGetTransports: any;

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {}

  private expand: object = {
    sms:false,
    call:false,
    email:false,
    push:false,
    viber:false,
    whatsapp:false,
    mail_notify:false,
    custom:false,
    settings:false,
    user_manage:false,
    finance:false
  }

  defaultItem(): UserRoleItem {
    return {
      name: '',
      show_finance_info: 1,
      ad_group_name: '',
      system_pages: []
    };
  }

  get transports(): string[] {
    return this.transportsList.map((ti: TransportItem) => ti.name);
  }

  async created() {
    this.actionGetTransports()
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "System account role",
        object_name: this.item.name,
        addititional_info: getTranslatedParams({id: this.$route.params.id})
      }
      this.actionGetItem(this.$route.params.id).then((data: PartnerItem) => {
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        this.actionLog(this.logObject);
      }).catch(()=>{
        this.actionLog({...this.logObject, action_status: "failed"});
      });
    } else {
      this.actionGetPages().then((pages:AllowedPage[]) => {
        pages.map(page=> {
          page.allowed = true
          this.item.system_pages?.push(page)
          this.itemSaved.system_pages?.push(page)
        })
      })
    }
  }

  back(): void {
    this.$router.push('/user_management/user_roles/');
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid:boolean = await this.validator.validate();
      if (valid) {
        try {
          await this.actionSave(this.item);
          await this.logChangeName('success');
          await this.logChangeRole('success');
          this.itemSaved = this.item;
          resolve()
          this.back();
        } catch (error) {
          await this.logChangeName('failed');
          await this.logChangeRole('failed');
          reject();
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "System account role",
          object_name: this.item.name,
          addititional_info: getTranslatedParams({id: this.$route.params.id})
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  async logChangeName (action_status: string) {
    if (isEqual(this.item.name, this.itemSaved.name)) return;
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: this.$route.params.id ? "Editing" : "Creation",
      action_status: action_status,
      object_type: "System account role",
      object_name: this.item.name,
      addititional_info: getTranslatedParams({id: this.$route.params.id})
    }
    await this.actionLog(this.logObject);
  }

  async logChangeRole (action_status: string) {
    if (!this.$route.params.id) return;
    const fieldsToCompare: Array<keyof UserRoleItem> = ['system_pages', 'ad_group_name', 'show_finance_info'];
    const isEqualAll = fieldsToCompare.every(field => isEqual(this.item[field], this.itemSaved[field]));
    if (isEqualAll) return;

    let show_finance_info = this.item.show_finance_info === 1 ? 'Да/Yes' : 'Нет/No';
    const getLabel = (all: boolean, some: boolean) => all ? 'Полностью доступен/Fully available' : some ? 'Частично доступен/Partially available' : 'Недоступен/Not available';

    const allSections = {
      'pages.sms': getLabel(this.allPagesSms, this.somePagesSms),
      'pages.call': getLabel(this.allPagesCall, this.somePagesCall),
      'pages.email': getLabel(this.allPagesEmail, this.somePagesEmail),
      'pages.push': getLabel(this.allPagesPush, this.somePagesPush),
      'pages.viber': getLabel(this.allPagesViber, this.somePagesViber),
      'pages.whatsapp': getLabel(this.allPagesWhatsApp, this.somePagesWhatsApp),
      'pages.mail_notify': getLabel(this.allPagesMailNotify, this.somePagesMailNotify),
      'pages.custom': getLabel(this.allPagesCustom, this.somePagesCustom),
      'pages.settings': getLabel(this.allPagesSettings, this.somePagesCustom),
      'pages.user_management': getLabel(this.allPagesUserManage, this.somePagesUserManage),
      'pages.finance': getLabel(this.allPagesFinance, this.somePagesFinance)
    }

    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Access rights modification",
      action_status: action_status,
      object_type: "System account role",
      object_name: this.item.name,
      addititional_info: {
        'Разделы/Sections': getTranslatedParams(allSections), ...getTranslatedParams({
          ad_group_name: this.item.ad_group_name,
          show_finance_info: show_finance_info
        })
      }
    }
    await this.actionLog(this.logObject);
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  get show_finance_info():number {
    return this.item.show_finance_info
  }

  set show_finance_info(value:number) {
    this.item.show_finance_info = (value ?? 0)
  }

  get allPagesSms(): boolean {
    return this.pagesSms.every(value => value.allowed)
  }

  set allPagesSms(val:boolean) {
    this.pagesSms.map(value => value.allowed = val)
  }

  get pagesSms() {
    return this.item.system_pages?.filter(value => !value.name.includes('sms.duplicate'))
      .filter(value => value.name.includes('sms')) ?? []
  }

  get somePagesSms(): boolean {
    return this.pagesSms.some(value => value.allowed) && !this.allPagesSms
  }

  get allPagesCall(): boolean {
    return this.pagesCall.every(value => value.allowed)
  }

  set allPagesCall(val:boolean) {
    this.pagesCall.map(value => value.allowed = val)
  }

  get pagesCall() {
    return this.item.system_pages?.filter(value => value.name.includes('call')) ?? []
  }

  get somePagesCall(): boolean {
    return this.pagesCall.some(value => value.allowed) && !this.allPagesCall
  }

  get allPagesEmail(): boolean {
    return this.pagesEmail.every(value => value.allowed)
  }

  set allPagesEmail(val:boolean) {
    this.pagesEmail.map(value => value.allowed = val)
  }

  get pagesEmail() {
    return this.item.system_pages?.filter(value => value.name.includes('email')) ?? []
  }

  get somePagesEmail(): boolean {
    return this.pagesEmail.some(value => value.allowed) && !this.allPagesEmail
  }

  get allPagesPush(): boolean {
    return this.pagesPush.every(value => value.allowed)
  }

  set allPagesPush(val:boolean) {
    this.pagesPush.map(value => value.allowed = val)
  }

  get pagesPush() {
    return this.item.system_pages?.filter(value => value.name.includes('push')) ?? []
  }

  get somePagesPush(): boolean {
    return this.pagesPush.some(value => value.allowed) && !this.allPagesPush
  }

  get allPagesViber(): boolean {
    return this.pagesViber.every(value => value.allowed)
  }

  set allPagesViber(val:boolean) {
    this.pagesViber.map(value => value.allowed = val)
  }

  get pagesViber() {
    return this.item.system_pages?.filter(value => value.name.includes('viber')) ?? []
  }

  get somePagesViber(): boolean {
    return this.pagesViber.some(value => value.allowed) && !this.allPagesViber
  }

    get allPagesWhatsApp(): boolean {
      return this.pagesWhatsApp.every(value => value.allowed)
    }

    set allPagesWhatsApp(val:boolean) {
      this.pagesWhatsApp.map(value => value.allowed = val)
    }

    get pagesWhatsApp() {
      return this.item.system_pages?.filter(value => value.name.includes('whatsapp')) ?? []
    }

    get somePagesWhatsApp(): boolean {
      return this.pagesWhatsApp.some(value => value.allowed) && !this.allPagesWhatsApp
    }

    get allPagesMailNotify(): boolean {
      return this.pagesMailNotify.every(value => value.allowed)
    }

    set allPagesMailNotify(val:boolean) {
      this.pagesMailNotify.map(value => value.allowed = val)
    }

    get pagesMailNotify() {
      return this.item.system_pages?.filter(value => value.name.includes('mail_notify')) ?? []
    }

    get somePagesMailNotify(): boolean {
      return this.pagesMailNotify.some(value => value.allowed) && !this.allPagesMailNotify
    }

    get allPagesCustom(): boolean {
      return this.pagesCustom.every(value => value.allowed)
    }

    set allPagesCustom(val:boolean) {
      this.pagesCustom.map(value => value.allowed = val)
    }

    get pagesCustom() {
      return this.item.system_pages?.filter(value => value.name.includes('custom')) ?? []
    }

    get somePagesCustom(): boolean {
      return this.pagesCustom.some(value => value.allowed) && !this.allPagesCustom
    }

    get allPagesSettings(): boolean {
      return this.pagesSettings.every(value => value.allowed)
    }

  set allPagesSettings(val:boolean) {
    this.pagesSettings.map(value => value.allowed = val)
  }

  get pagesSettings() {
    return this.item.system_pages?.filter(value => !value.name.includes('distr'))
      .filter(value => value.name.includes('settings')
        || value.name.includes('export.reports') || value.name.includes('sms.duplicate')) ?? []
  }

  get somePagesSettings(): boolean {
    return this.pagesSettings.some(value => value.allowed) && !this.allPagesSettings
  }

  get allPagesUserManage(): boolean {
    return this.pagesUserManage.every(value => value.allowed)
  }

  set allPagesUserManage(val:boolean) {
    this.pagesUserManage.map(value => value.allowed = val)
  }

  get pagesUserManage() {
    return this.item.system_pages?.filter(value => value.name.includes('user.manage')
      || value.name.includes('distr')).sort(dynamicSort("name", "asc")) ?? []
  }

  get somePagesUserManage(): boolean {
    return this.pagesUserManage.some(value => value.allowed) && !this.allPagesUserManage
  }

  get allPagesFinance(): boolean {
    return this.pagesFinance.every(value => value.allowed)
  }

  set allPagesFinance(val:boolean) {
    this.pagesFinance.map(value => value.allowed = val)
  }

  get pagesFinance() {
    return this.item.system_pages?.filter(value => value.name.includes('finance')) ?? []
  }

  get somePagesFinance(): boolean {
    return this.pagesFinance.some(value => value.allowed) && !this.allPagesFinance
  }
}
